import { DashboardSettings } from "./dashboard-settings";

export default function DashboardSettingsPage() {
  return <DashboardSettings />;
}
